import { useEffect } from 'react';
import API from '../API';
import { activeMiniGame, setMiniGameActivity } from '../components/UnityGame/miniGameActivity';

/** Runs for spectators too: opening a game panel is not required to see the paired badges. */
export function useMiniGameActivity(accessToken: string | null | undefined, eventId: string, enabled: boolean, unityReady: boolean) {
  useEffect(() => {
    if (!enabled || !accessToken) return;
    let disposed = false;
    let pending = false;
    const publish = (matches: ReturnType<typeof activeMiniGame>) => {
      setMiniGameActivity(matches);
      if (unityReady) window.sendMessageToUnity?.('BrowserBridge', 'ReceivePayload', JSON.stringify({
        eventType: 'MiniGameActivity', payload: JSON.stringify({ matches, reducedMotion: window.matchMedia?.('(prefers-reduced-motion: reduce)').matches ?? false }),
      }));
    };
    const refresh = async () => {
      if (disposed || pending) return;
      pending = true;
      try {
        const results = await Promise.all(['tic-tac-toe', 'chess'].map(async gameId => {
          try {
            const response = await API.getMiniGame(accessToken, { eventId, gameId });
            return response.ok ? activeMiniGame(gameId, await response.json()) : [];
          } catch { return []; }
        }));
        if (!disposed) publish(results.flat());
      } finally { pending = false; }
    };
    void refresh();
    const timer = window.setInterval(refresh, 3000);
    window.addEventListener('miniGameUpdated', refresh);
    return () => { disposed = true; window.clearInterval(timer); window.removeEventListener('miniGameUpdated', refresh); publish([]); };
  }, [accessToken, eventId, enabled, unityReady]);
}
